// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xNqM0","item":"styles_item__2CsaB","indicator":"styles_indicator__suKSm","label":"styles_label__1v4GW"};